import React from 'react';
import { sr_only } from './styles.mod.scss';

const ScreenReaderText = ({ children }) => (
  <span className={sr_only}>{children}</span>
);

export default ScreenReaderText;
